import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import Resource from '@/api/Resource';
import Book from '@/api/mjegb/Book';
import ApiWrapper from '@/api/ApiWrapper';
import networkBoundResource from '@/api/networkBoundResource';
import unwrapApiWrapper from '@/api/unwrapApiWrapper';
import BookReference from '@/api/mjegb/BookReference';

export default class BookRepository {
    private readonly client: HttpClient;
    private readonly baseUrl: string;

    public constructor(client: HttpClient, apiEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint + '/book';
    }

    public findAll(): Observable<Resource<BookReference[]>> {
        const observable = this.client.get<ApiWrapper<BookReference[]>>('', { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public findById(id: number): Observable<Resource<Book>> {
        const observable = this.client.get<ApiWrapper<Book>>('' + id, { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public save(book: Book): Observable<Resource<Book>> {
        const observable = this.client.post<ApiWrapper<Book>>('', book, { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public delete(id: number): Observable<Resource<string>> {
        const observable = this.client.delete<ApiWrapper<string>>('' + id, { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }
}
